// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
import ToggleController from "./toggle_controller"
import TimezoneController from "./timezone_controller"
import AnswerTimerController from "./answer_timer_controller"

application.register("alert", AlertController)
application.register("toggle", ToggleController)
application.register("timezone", TimezoneController)
application.register("answer-timer", AnswerTimerController)

import AssessmentTimerController from "./assessment_timer_controller"
import AssessmentCardController from "./assessment_card_controller"

application.register("assessment-timer", AssessmentTimerController)
application.register("assessment-card", AssessmentCardController)
